<div fxLayout="row" style="margin-top: 10px">
  <div fxFlex="100" style="padding: 5px">
    <form *ngIf="variety_form.is_avalible">
      <mat-card>
        <mat-card-header>
          <mat-card-title> Atributos de variedad </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Nombre de variedad</mat-label>
                <input
                  matInput
                  type="text"
                  name="variety_name"
                  [(ngModel)]="variety_form.variety_name"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field
                appearance="outline"
                *ngIf="speciesObs$ | async as specieList"
              >
                <mat-label>Especie</mat-label>
                <mat-select
                  [(ngModel)]="variety_form.species_id"
                  name="species_id"
                >
                  <mat-option
                    *ngFor="let specie of specieList.data"
                    [value]="specie.species_id"
                  >
                    {{ specie.species_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Nombre comun</mat-label>
                <input
                  matInput
                  type="text"
                  name="common_name"
                  [(ngModel)]="variety_form.common_name"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Sinonimos</mat-label>
                <input
                  matInput
                  type="text"
                  name="synonyms"
                  [(ngModel)]="variety_form.synonyms"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Significado</mat-label>
                <input
                  matInput
                  type="text"
                  name="meaning"
                  [(ngModel)]="variety_form.meaning"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Descripción</mat-label>
                <input
                  matInput
                  type="text"
                  name="description"
                  [(ngModel)]="variety_form.description"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Descripción (Quechua)</mat-label>
                <input
                  matInput
                  type="text"
                  name="description_quechua"
                  [(ngModel)]="variety_form.description_quechua"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field
                appearance="outline"
                *ngIf="varietalGroupObs$ | async as varietalGroupList"
              >
                <mat-label>Grupo varietal</mat-label>
                <mat-select
                  [(ngModel)]="variety_form.varietal_group"
                  name="varietal_group"
                >
                  <mat-option
                    *ngFor="let varietalGroup of varietalGroupList.data"
                    [value]="varietalGroup"
                  >
                    {{ varietalGroup }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Es original</mat-label>
                <mat-select
                  [(value)]="variety_form.is_original"
                  [disabled]="true"
                >
                  <mat-option value="true">Si</mat-option>
                  <mat-option value="false">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <input
                  matInput
                  type="text"
                  name="status"
                  [(ngModel)]="variety_form.status"
                />
              </mat-form-field>
            </div>

            <div fxFlex="49">
              <mat-form-field
                appearance="outline"
                *ngIf="userObs$ | async as userList"
              >
                <mat-label>Institución</mat-label>
                <mat-select
                  [(ngModel)]="variety_form.institution_id"
                  name="institution_id"
                >
                  <mat-option
                    *ngFor="let user of userList.data"
                    [value]="user.user_id"
                  >
                    {{ user.username }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex="100">
              <mat-form-field appearance="outline">
                <mat-label>Comentario</mat-label>
                <textarea
                  matInput
                  name="comment"
                  [(ngModel)]="variety_form.comment"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <br />

      <div *ngIf="group_list">
        <div *ngFor="let group_object of group_list">
          <mat-card>
            <mat-card-header>
              <mat-card-title> {{ group_object.title }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                <div
                  fxFlex="49"
                  *ngFor="let descriptor of group_object.descriptor_list"
                >
                  <!-- ============================================ -->
                  <div
                    *ngIf="
                      descriptor.descriptor_type == 'text' &&
                      descriptor.descriptor_categories
                    "
                  >
                    <!-- {descriptor_category_id: 21, value: '1', description: 'Blanco'} -->
                    <mat-form-field appearance="outline">
                      <mat-label>{{ descriptor.descriptor_label }}</mat-label>
                      <mat-select
                        name="{{ descriptor.descriptor_name }}"
                        [(ngModel)]="descriptor.descriptor_value"
                        (selectionChange)="addDescriptor(descriptor, $event)"
                      >
                        <mat-option
                          *ngFor="
                            let category of descriptor.descriptor_categories
                          "
                          [value]="category"
                        >
                          {{ category.description }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- ============================================ -->
                  <div
                    *ngIf="
                      descriptor.descriptor_type == 'text' &&
                      !descriptor.descriptor_categories
                    "
                  >
                    <mat-form-field appearance="outline">
                      <mat-label>{{ descriptor.descriptor_label }}</mat-label>
                      <input
                        matInput
                        type="text"
                        (change)="addDescriptor(descriptor, $event)"
                        [value]="descriptor.descriptor_value"
                      />
                    </mat-form-field>
                  </div>
                  <!-- ============================================ -->
                  <div *ngIf="descriptor.descriptor_type == 'numeric'">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ descriptor.descriptor_label }}</mat-label>
                      <input
                        matInput
                        type="number"
                        (change)="addDescriptor(descriptor, $event)"
                        [value]="descriptor.descriptor_value"
                      />
                    </mat-form-field>
                  </div>
                  <!-- ============================================ -->
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <br />
        </div>
      </div>

      <app-template-multimedia
        *ngIf="variety_form"
        [(main_object)]="variety_form"
        [(main_object_id)]="id"
      ></app-template-multimedia>
      <br />

      <div class="button-row" style="display: flex; align-items: center">
        <button mat-flat-button color="primary" type="button" (click)="save()">
          Guardar variedad
        </button>

        <button
          mat-stroked-button
          color="primary"
          routerLink="/tablero/variety-list-edit"
        >
          Cancelar
        </button>
        <button mat-button>Eliminar</button>
      </div>
    </form>
  </div>
</div>
